export default __webpack_public_path__ + "static/structural1-8dc8b1acc5e4803539b667dddf53766f.png";